import React, { useState, useEffect } from 'react';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';


export default function TypingEffect({ text, speed = 50 }) {
  const [displayText, setDisplayText] = useState('');
  const [index, setIndex] = useState(0);
  const [ opacity, setOpacity ] = useState(0);

    // Ustawienie animacji `opacity`

  useEffect(() => {
    if (text && text !== 'undefined' && text != displayText) {
      // console.log('text', text)
      const intervalId = setInterval(() => {
        
        setIndex((prevIndex) => {
          const newIndex = prevIndex + 1;
          if (newIndex >= text.length) {
            clearInterval(intervalId);
            setDisplayText(text);
            return newIndex;
          }
          setDisplayText((prev) => prev + text[index]);
          return newIndex;
        });
      }, speed);

      return () => clearInterval(intervalId);
    }
  }, [text, speed, index]);

  useEffect( () =>{
    if (text && text !== 'undefined' && text != ''){
      setOpacity(1)
    }
  }, [text])

  return (
    <div
      style={{
        // backgroundColor: '#919191',
        background: 'linear-gradient(34deg, rgba(106, 106, 106, 0.9) 0%, rgba(87, 82, 82, 0.9) 100%)',
        borderRadius: '10px',
        color: 'black',
        height: '65px',
        width: '90%',
        paddingLeft: '10px',
        paddingRight: '10px',
        border: 'solid 1px white',
        marginBottom: '10px',
        textAlign: 'center',
        boxShadow: '3px 3px 5px 0px rgba(0, 0, 0, 0.35)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        opacity: 1,
        transition: 'opacity 0.5s ease', // Dodanie transition dla opacity
      }}
    >
      {displayText?displayText:<Stack spacing={1}>
        <Skeleton variant="text" marginTop={0} sx={{ width: '200px', fontSize: '1.1rem' }} />
        {/* <Skeleton variant="text" marginTop={0} width={330} sx={{ fontSize: '1.1rem' }} /> */}

      </Stack>}
    </div>
  );
}

// Użycie komponentu
// <TypingEffect text={item.title} speed={100} />